export const SECTION_LABELS = {
  AWAITING_PICKUP: 'Awaiting pickup',
  COMPLETED_DELIVERY: 'Completed delivery',
  COMPLETED_PICKUP: 'Completed pickup',
  DUE_FOR_REFILL: 'Medications ready to refill',
  NEW_PRESCRIPTIONS: 'New medications',
  PENDING_TRANSFER: 'Pending prescription transfer',
  TRANSFER_REQUESTS: 'Requested prescription transfer',
  UNCONFIRMED_SHIPMENT: 'Pending delivery',
  UPCOMING_DELIVERY: 'Upcoming delivery',
  UPCOMING_PICKUP: 'Upcoming pickup',
  UPDATE_INSURANCE: 'Update your insurance',
  UPDATE_PAYMENT_METHOD: 'Failed payment',
};

export const UNCONFIRMED_SHIPMENT_LABELS = {
  generic_confirmation_error: 'Please try again or message support if the problem persists.',
};
